const sanitizeHTML = require('sanitize-html')

const escapeHtml = (text, opts = {}, customOpts = {}) => {
  const { allowAmpersand, allowDoubleQuotes, allowSingleQuotes } = customOpts
  const sanitizerOpts = {
    allowedTags: [],
    ...opts
  }

  let sanitizedHtml = sanitizeHTML(text, sanitizerOpts)

  if (allowAmpersand) {
    sanitizedHtml = sanitizedHtml.replace(/&amp;/g, '&')
  }
  if (allowDoubleQuotes) {
    sanitizedHtml = sanitizedHtml.replace(/&quot;/g, '"')
  }

  if (allowSingleQuotes) {
    sanitizedHtml = sanitizedHtml.replace(/&#39;/g, "'")
  }

  return sanitizedHtml
}

const _escapeIfTagHasInvalidAttribs = (tagName, attribs) => {
  // Check if the 'href' attribute exists, and if not, remove the tag
  if ((tagName === 'a' && !attribs.href) || (tagName === 'img' && !attribs.src)) {
    return {
      tagName: '', // Remove the tag
      attribs: {}
    }
  }
  return { tagName, attribs }
}

const replaceHtmlCharacters = (text) => {
  text = text.replace(/&amp;/g, '&')
  text = text.replace(/&quot;/g, '"')
  text = text.replace(/&apos;/g, "'")
  text = text.replace(/&#39;/g, "'")
  return text
}

const ALLOWED_TAGS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'figcaption',
  'figure',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'b',
  'br',
  'em',
  'small',
  'span',
  'strong',
  'img'
]

const escapeRichTextContentHtml = (text, allowedTags = ALLOWED_TAGS) => {
  const sanitizerOpts = {
    allowedTags,
    allowedAttributes: {
      a: ['href', 'name', 'target'],
      img: ['src', 'alt', 'title', 'width', 'height']
    },
    transformTags: {
      a: (tagName, attribs) => _escapeIfTagHasInvalidAttribs(tagName, attribs),
      img: (tagName, attribs) => _escapeIfTagHasInvalidAttribs(tagName, attribs),
      '*': (tagName, attribs) => {
        // Check if the tag is not in the allowedTags list
        if (!allowedTags.includes(tagName)) {
          // Remove the tag and its content
          return {
            tagName: '',
            attribs: {}
          }
        }
        return { tagName, attribs }
      }
    }
  }

  let sanitizedHtml = sanitizeHTML(text, sanitizerOpts)
  sanitizedHtml = sanitizedHtml.trim()
  sanitizedHtml = replaceHtmlCharacters(sanitizedHtml)
  return sanitizedHtml
}

module.exports = {
  escapeHtml,
  escapeRichTextContentHtml
}
